module.exports = __webpack_public_path__ + "static/media/3 05 Tulleord Vuks er feil-norming.a4cd102f.mp3";